// client/src/pages/ForgotPassword.js
import React, { useState } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import Header from '../components/Header';
import Footer from '../components/Footer';
import GradientButton from '../components/GradientButton';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [showBubble, setShowBubble] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleReset = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await sendPasswordResetEmail(auth, email);
      setEmail(''); // Clear the field
      setShowBubble(true);
    } catch (err) {
      setError('Error sending reset email. Please try again.');
      console.error('Reset error:', err);
    }
  };

  const handleCloseBubble = () => {
    setShowBubble(false);
    navigate('/login');
  };

  return (
    <>
      <Header />

      {/* Success Overlay Bubble */}
      {showBubble && (
  <div
    role="dialog"
    aria-modal="true"
        style={{
      position: 'fixed',
      inset: 0,
      background: 'rgba(15, 23, 42, 0.5)',
      zIndex: 9999,
      display: 'flex',
      alignItems: 'flex-start',   // move card up
      justifyContent: 'center',
      padding: '1rem',
      paddingTop: '29vh'           // ~a quarter inch; adjusts with screen height
    }}

  >

          <div
            style={{
              backgroundColor: '#fff',
              borderRadius: '16px',
              width: '100%',
              maxWidth: '720px',
              padding: '1.75rem',
              boxShadow: '0 20px 50px rgba(0,0,0,0.25)',
              position: 'relative',
              animation: 'slideDown 0.35s cubic-bezier(0.32,0.72,0.31,1.0)'
            }}
          >
            {/* Header line */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.6rem', marginBottom: '1rem', textAlign: 'center' }}>

              <span style={{ fontSize: '1.5rem' }}>✉️</span>
              <h3
                style={{
                  margin: 0,
                  fontSize: 'clamp(1.25rem, 4vw, 1.5rem)',
                  fontWeight: 800,
                  color: '#16a34a' // green text for success
                }}
              >
                Your password reset link has been sent!
              </h3>
            </div>

 {/* Yellow attention banner (repeats gently, centered, no clipping) */}
<div
  style={{
    textAlign: 'center',
    margin: '0.25rem 0 1rem',
    padding: '0.35rem 0',   // space for the scale animation
    overflow: 'visible'
  }}
>
  <span
    style={{
      background: '#FDE047',
      color: '#111827',
      borderRadius: '12px',
      padding: '0.9rem 1rem',
      fontWeight: 900,
      boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
      animation: 'attentionCycle 3s ease-in-out infinite',
      letterSpacing: '0.02em',
      textTransform: 'uppercase',
      display: 'inline-block',  // prevents full-width stretch
      maxWidth: '560px',
      width: 'auto',
      whiteSpace: 'normal',
      verticalAlign: 'middle',
      transformOrigin: 'center', // avoid clipping on scale
      willChange: 'transform'    // hint: smoother, fewer layout quirks
    }}
  >
    ⚠️ CHECK YOUR SPAM FOLDER FIRST!
  </span>
</div>
            {/* Body copy */}
            <p
              style={{
                margin: '0 0 0.5rem 0',
                color: '#374151',
                fontSize: '1rem',
                lineHeight: 1.55,
                textAlign: 'center'
              }}
            >
              Check both your <strong>inbox</strong> and <strong>Spam</strong> folder for this email.
            </p>
            <p
              style={{
                margin: '0 0 1rem 0',
                color: '#EA580C', // orange-600 for emphasis
                fontWeight: 700,
                textAlign: 'center'
              }}
            >
              It lands in spam the majority of the time.
            </p>

            {/* Blue action button */}
            <div style={{ textAlign: 'center', marginTop: '0.5rem', overflow: 'visible' }}>
              <button
                onClick={handleCloseBubble}
                style={{
                  padding: '0.95rem 1.6rem',
                  background: 'linear-gradient(135deg, #1E9FF2 0%, #14B1E7 100%)',
                  color: '#FFF',
                  fontWeight: 700,
                  fontSize: '1.05rem',
                  border: 'none',
                  borderRadius: '12px',
                  cursor: 'pointer',
                  boxShadow: '0 8px 25px rgba(30,159,242,0.5), 0 4px 12px rgba(0,0,0,0.15)',
                  transition: 'transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease',
                  minHeight: '48px',
                  textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                  letterSpacing: '0.5px'
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = 'translateY(-2px) scale(1.01)';
                  e.target.style.boxShadow =
                    '0 12px 35px rgba(30,159,242,0.6), 0 6px 18px rgba(0,0,0,0.2)';
                  e.target.style.background =
                    'linear-gradient(135deg, #0EA5E9 0%, #0284C7 100%)';
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = 'translateY(0) scale(1)';
                  e.target.style.boxShadow =
                    '0 8px 25px rgba(30,159,242,0.5), 0 4px 12px rgba(0,0,0,0.15)';
                  e.target.style.background =
                    'linear-gradient(135deg, #1E9FF2 0%, #14B1E7 100%)';
                }}
              >
                Close & Return to Login
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Orange Header */}
      <div
        style={{
          backgroundColor: '#F7931E',
          padding: '2rem 1rem',
          textAlign: 'center'
        }}
      >
        <h1
          style={{
            margin: '0 0 1rem 0',
            color: '#FFF',
            fontWeight: 'bold',
            fontSize: 'clamp(2rem, 8vw, 3rem)',
            textShadow: '2px 2px rgba(0,0,0,0.2)',
            lineHeight: '1.2',
            fontFamily: "'Open Sans', sans-serif"
          }}
        >
          Reset Your Password
        </h1>
        <p
          style={{
            color: '#FFF',
            fontSize: 'clamp(1rem, 4vw, 1.25rem)',
            margin: 0,
            opacity: 0.95,
            maxWidth: '600px',
            marginLeft: 'auto',
            marginRight: 'auto',
            fontFamily: "'Open Sans', sans-serif"
          }}
        >
          Enter your account email address to receive a password reset link.
        </p>
      </div>

      {/* Form Card */}
      <div
        style={{
          maxWidth: '400px',
          margin: '3rem auto',
          padding: '2rem',
          backgroundColor: '#fff',
          borderRadius: '8px',
          boxShadow: '0 0 10px rgba(0,0,0,0.1)'
        }}
      >
        <form onSubmit={handleReset} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <input
            type="email"
            placeholder="Your Account Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={{
              padding: '0.75rem',
              fontSize: '1rem',
              borderRadius: '4px',
              border: '1px solid #ccc',
              width: '100%'
            }}
            autoComplete="email"
          />

          {/* Green submit */}
<GradientButton
  variant="emerald"
  type="submit"
  style={{
    padding: '1rem 1rem',
    fontSize: '1.05rem',
    transition: 'transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease',
    width: '100%'
  }}
>
  Send Password Reset Link
</GradientButton>

        </form>

        {error && (
          <div
            style={{
              marginTop: '1.2rem',
              color: '#e74c3c',
              background: '#fff0f0',
              border: '1px solid #e74c3c',
              borderRadius: '4px',
              padding: '0.7rem 1rem',
              fontWeight: 500,
              textAlign: 'center'
            }}
          >
            {error}
          </div>
        )}
      </div>

      <Footer />

      {/* Animations for overlay card + repeating attention cycle */}
      <style>
        {`
          @keyframes slideDown {
            0% { transform: translateY(-40px); opacity: 0; }
            100% { transform: translateY(0); opacity: 1; }
          }

          /* Single shake (kept for future use) */
          @keyframes attentionShake {
            0% { transform: scale(1) rotate(0deg); }
            10% { transform: scale(1.03) rotate(-2deg); }
            20% { transform: scale(1.12) rotate(2deg); }
            30% { transform: scale(1.08) rotate(-2deg); }
            40% { transform: scale(1.10) rotate(2deg); }
            50% { transform: scale(1.06) rotate(-1deg); }
            60% { transform: scale(1.07) rotate(1deg); }
            70% { transform: scale(1.04) rotate(-1deg); }
            80% { transform: scale(1.02) rotate(1deg); }
            90% { transform: scale(1.00) rotate(0deg); }
            100% { transform: scale(1) rotate(0deg); }
          }

          /* Repeating cycle: idle → quick shake → settle (every 6s) */
          @keyframes attentionCycle {
            0%, 65% { transform: scale(1) rotate(0deg); }
            70% { transform: scale(1.03) rotate(-2deg); }
            75% { transform: scale(1.12) rotate(2deg); }
            80% { transform: scale(1.08) rotate(-2deg); }
            85% { transform: scale(1.10) rotate(2deg); }
            90% { transform: scale(1.06) rotate(-1deg); }
            95% { transform: scale(1.02) rotate(0deg); }
            100% { transform: scale(1) rotate(0deg); }
          }
        `}
      </style>
    </>
  );
};

export default ForgotPassword;
